import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {FormError} from "@/components/FormError";

interface VoucherFormData {
  code: string;
}

const schema = yup.object().shape({
  code: yup.string().required("Voucher code is required"),
});

export const VoucherPage: React.FC = () => {
  const [unlockedPackages, setUnlockedPackages] = React.useState<string[]>([]);
  const [successMessage, setSuccessMessage] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<VoucherFormData>({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data: VoucherFormData) => {
    try {
      // Implementar chamada API para resgatar voucher
      console.log("Redeeming voucher:", data.code);
      setSuccessMessage("Voucher redeemed successfully!");
      setUnlockedPackages(["Basic English"]);
      setErrorMessage("");
    } catch (error) {
      setErrorMessage("Invalid voucher code");
      setSuccessMessage("");
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Redeem Voucher</h1>

      <div className="max-w-md mx-auto">
        <p className="text-lg text-gray-700 mb-6">
          Welcome to the voucher redemption page. Enter your voucher code below to unlock special packages and benefits.
        </p>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div>
            <label
              htmlFor="voucher-code"
              className="block text-sm font-medium text-gray-700"
            >
              Voucher Code
            </label>
            <input
              id="voucher-code"
              type="text"
              {...register("code")}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
            />
            <FormError message={errors.code?.message} />
          </div>

          <button
            id="redeem-voucher"
            type="submit"
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Redeem Voucher
          </button>
        </form>

        {successMessage && (
          <div
            id="success-message"
            className="mt-4 p-4 bg-green-100 text-green-700 rounded-md"
          >
            {successMessage}
          </div>
        )}

        {errorMessage && (
          <div
            id="error-message"
            className="mt-4 p-4 bg-red-100 text-red-700 rounded-md"
          >
            {errorMessage}
          </div>
        )}

        {unlockedPackages.length > 0 && (
          <div className="mt-8">
            <h2 className="text-xl font-semibold mb-4">Unlocked Packages</h2>
            <div className="space-y-2">
              {unlockedPackages.map((pkg, index) => (
                <div
                  key={index}
                  className="unlocked-package p-4 bg-white rounded-md shadow"
                >
                  {pkg}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
